import React, { useReducer } from "react";
import AlertContext from "./alertContext";
import alertReducer from "./alertReducer";
import { v4 as uuid } from "uuid";
import axios from "axios";

import { SET_ALERT, REMOVE_ALERT, ALERT_ERROR, GET_INVOICE_ALERT, REMOVE_INVOICE_ALERT } from "../types";

const AlertState = (props) => {
  const initialState = {
    alerts: [],
    invoiceAlerts: [],
  };

  const [state, dispatch] = useReducer(alertReducer, initialState);

  // set alert
  const setAlert = (msg, type, timeout = 5000) => {
    const id = uuid();
    dispatch({
      type: SET_ALERT,
      payload: { msg, type, id },
    });

    // setTimeout(() => dispatch({ type: REMOVE_ALERT, payload: id }), timeout);
  };

  const getInvoiceAlerts = async () => {
    try {
      const res = await axios.get("/api/alert/unread").then((res) => {
        const myAlerts = res.data.map((alert) => {
          let newAlert = {};
          newAlert.type = "danger";
          newAlert.id = alert._id;
          newAlert.msg = alert.content;
          return newAlert;
        });
        dispatch({ type: GET_INVOICE_ALERT, payload: myAlerts });
      });
    } catch (err) {
      dispatch({ type: ALERT_ERROR });
    }
  };
  const removeAlert = async (id) => {
    dispatch({ type: REMOVE_ALERT, payload: id });
  };

  // update
  const updateInvoiceAlert = async (id) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios.put(`/api/alert/update/read/${id}`, config);
      dispatch({ type: REMOVE_INVOICE_ALERT, payload: id });
    } catch (err) {
      dispatch({ type: ALERT_ERROR });
    }
  };

  const setAlertForShop = async (alert, invoice) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios.post("/api/alert/", { alert, invoice }, config);
      //   dispatch({ type: ADD_COMMENT, payload: res.data });
    } catch (err) {
      //   dispatch({ type: COMMENT_ERROR });
    }
  };

  return (
    <AlertContext.Provider
      value={{
        alerts: state.alerts,
        invoiceAlerts: state.invoiceAlerts,
        setAlert,
        // getInvoiceAlerts,
        updateInvoiceAlert,
        setAlertForShop,
        getInvoiceAlerts,
        removeAlert,
      }}
    >
      {props.children}
    </AlertContext.Provider>
  );
};

export default AlertState;
